import RootState from 'typings/RootState'
import { ProjectData } from './types'
import { Event } from 'features/types/event'

export const selectData = (state: RootState): ProjectData[] =>
  state.qcProjects.data

export const selectEvent = (state: RootState): Event => state.qcProjects.event
